require('../vendor/bootstrap/js/bootstrap.min');
require('jquery');
import { jsonLint } from '../ts/jsonLint';

window.jsonLint = jsonLint;
window.$ = require('jquery');
window.jQuery = require('jquery');

